import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSession } from './context/slices/session/thunks';
import RoutesNotAuthenticated from './routes/RoutesNotAuthenticated';
import RoutesAuthenticated from './routes/RoutesAuthenticated';
import LoadingIcon from './components/loading/LoadingIcon';

const App = () => {
  const dispatch = useDispatch();
  const { isLoading, sessionValidated } = useSelector(state => state.session);

  useEffect(() => {
    dispatch(getSession());
  }, [dispatch])

  if (isLoading) {
    return <LoadingIcon />
  }

  if (!sessionValidated) {
    return <RoutesNotAuthenticated />
  }

  return <RoutesAuthenticated />
}

export default App;
